var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Carrito'),_vm._v(" "),_c('div',{staticClass:"overlay-micarrito"}),_vm._v(" "),(_vm.showHeader)?_c('header-partial'):_vm._e(),_vm._v(" "),(_vm.showHeaderCheckout)?_c('header-checkout-partial'):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),(_vm.showFooter)?_c('footer-partial'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14004721","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 